<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20.822"
        height="19.366"
        viewBox="0 0 20.822 19.366"
    >
        <g id="icon_changeshoe" transform="translate(1.029 1)">
            <path
                id="Path_477"
                data-name="Path 477"
                d="M16.667,13.272A8.564,8.564,0,0,1,8.408,19.38,8.711,8.711,0,0,1,.072,13c-1.139-3.79-1.346,3.244-1.346,3.244"
                transform="translate(1.275 -2.014)"
                fill="none"
                stroke="#854b97"
                stroke-linecap="round"
                stroke-width="2"
            />
            <path
                id="Path_478"
                data-name="Path 478"
                d="M-1.275,17.989a8.564,8.564,0,0,1,8.259-6.108,8.711,8.711,0,0,1,8.336,6.377c1.139,3.79,1.346-3.244,1.346-3.244"
                transform="translate(2.097 -11.882)"
                fill="none"
                stroke="#854b97"
                stroke-linecap="round"
                stroke-width="2"
            />
        </g>
    </svg>
</template>
